/**
 * @file   cache.js 缓存控制
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2019-09-04
 */

// 类似储物柜
export const locker = {
    count: 1,
    blackBox: {},

    /**
     * 存包裹，返你一个钥匙
     *
     * @param  {Mixed} goods 包裹
     * @return {string} 🔑
     */
    save(goods) {
        const key = '__^0^key_' + this.count;
        this.blackBox[key] = goods;
        return key;
    },

    /**
     * 取回包裹，需要一把钥匙
     *
     * @param  {string} key 🔑
     * @return {Mixed} 包裹
     */
    take(key) {
        return this.blackBox[key] !== undefined ? this.blackBox[key] : false;
    },

    /**
     * 查询有没有这个包裹
     *
     * @param  {Mixed} goods 包裹
     * @return {boolean}
     */
    check(goods) {
        let result = false;
        const blackBox = this.blackBox;
        Object.keys(blackBox).forEach((value, key) => {
            if (blackBox.hasOwnProperty(key) && goods === value) {
                result = true;
                return;
            }
        });

        return result;
    },

    /**
     * 清点包裹
     *
     * @param  {Function} cbk
     */
    each(cbk) {
        Object.keys(this.blackBox).forEach(cbk);
    },

    /**
     * 定期清理柜子
     *
     * @param  {}
     * @return {}
     * @toado
     */
    cleaner() {}
};
